import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(function () {
    // Check if the user is on a mobile device
    if (wixWindow.formFactor === "Mobile") {
        // Get the window's width
        let windowWidth = wixWindow.getBoundingRect().width;

        // Optional: Check if the screen width is less than or equal to 1000px
        if (windowWidth <= 1000) {
            // Redirect to mobile site (replace with your mobile site URL)
            wixLocation.to("https://www.rahulsir.co.in");
        }
    }
});
